
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface TrendChartProps {
  data: {
    name: string;
    value: number;
    date?: string;
  }[];
}

const TrendChart: React.FC<TrendChartProps> = ({ data }) => {
  if (data.length === 0) return <p className="text-gray-500 italic">No trend data available</p>;
  
  return (
    <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
      <h3 className="text-sm font-medium mb-3">Expiry Trend</h3>
      <div className="h-[180px]">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip 
              formatter={(value: number) => [`${value} items`, 'Expiring']}
              labelFormatter={(label) => {
                const item = data.find(d => d.name === label);
                return item?.date || label;
              }}
              contentStyle={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: '4px' }}
            />
            <Line 
              type="monotone" 
              dataKey="value" 
              stroke="#8b5cf6" 
              strokeWidth={2}
              activeDot={{ r: 6 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default TrendChart;
